<template>
  <div>
    <div class="main-container">
      <div class="container">
        <div v-if="ready" class="check-container">
          <div>
            <v-avatar size="118" class="check-avatar">
              <span class="primary--text headline">
                <v-icon class="primary--text" size="80" dark>mdi-check</v-icon>
              </span>
            </v-avatar>
            <h1>{{getMessage('TTL_LISTO')}}</h1>
            <template v-if="salaAdministrativaDisplay">
              <h3>{{ getMessage('MSG_SERAS_LLAMADO_POR_NOMBRE',['']) }}</h3>
              <h2 class="">{{ salaAdministrativaDisplay }}</h2>
            </template>
            <h2 v-else>{{getMessage('MSG_TOME_ASIENTO')}}</h2>
          </div>
        </div>
        <h1 v-else>{{getMessage('MSG_IMPRIMIENTO_NUMERO')}}</h1>
      </div>
    </div>
    <div v-show="false">
      <div id="printMe">
        <div
          style="
            border-style: solid;
            border-width: medium;
            width: 240px;
            height: 270px;
            text-align: center;
            page-break-before: always;
            "
            ref="divNumber"
          >
          <br />
          <p style="font-size: 14px; margin: 10px;">
            <strong>{{headerDisplay}}</strong>
          </p>
          <p style="font-size: 60px; margin: 10px;">
            <strong>{{numberDisplay}}</strong>
          </p>
          <p style="font-size: 12px; margin: 10px;">{{getMessage('MSG_AGUARDA_SER_LLAMADO')}}</p>
          <br />
          <p style="font-size: 12px; margin: 10px;">{{dateDisplay}}</p>
          <p style="font-size: 12px; margin: 10px; ">{{footerDisplay}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

let ipcRenderer

if (typeof process !== 'undefined' && process.type === 'renderer') {
  const { ipcRenderer: electronIpcRenderer } = require('electron')
  ipcRenderer = electronIpcRenderer
}

export default {
  props: {
    number: {
      type: String
    },
    date: {
      type: String
    },
    header: {
      type: String
    },
    footer: {
      type: String
    },
    serviceId: {
      type: Number,
      required: false
    },
    numRecId: {
      type: Number,
      required: false
    },
    accionId: {
      type: Number,
      required: false
    },
    salaAdministrativa: {
      type: String,
      required: false,
      default: null
    },
    mostrarSalaDiferente: {
      type: Boolean,
      default: false
    },
    salaTurno: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ready: false,
      numberDisplay: this.number,
      dateDisplay: this.date,
      headerDisplay: this.header,
      footerDisplay: this.footer,
      serviceDisplay: this.service,
      salaAdministrativaDisplay: this.salaAdministrativa
    }
  },
  mounted: function () {
    this.printNumber()
  },
  computed: {
    ...mapGetters('InitConfig', ['getSalaActual']),
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  methods: {
    ...mapActions('Appointment', ['generarNumeroRecepcion']),
    ipcPrint () {
      if (!ipcRenderer) return
      const content = this.$refs.divNumber.outerHTML
      ipcRenderer.send('app:print', content)
    },
    printNumber () {
      if (this.number) {
        // nro ya generado, solo imprimir
        this.numberDisplay = this.number
        this.dateDisplay = this.date
        this.headerDisplay = this.header
        this.footerDisplay = this.footer
        this.$nextTick(() => {
          this.print()
        })
      } else {
        // generar e imprimir
        var vm = this
        vm.generarNumeroRecepcion({
          // salaId: this.getSalaActual().salaId,
          numRecId: this.numRecId,
          motivo: this.numRecId ? 1001 : 1003, // 1001: sin turno - 1003: turno no encontrado
          accionId: this.accionId
        })
          .then(response => {
            this.numberDisplay = response.data.numeroDisplay
            this.dateDisplay = response.data.fechaHora
            this.headerDisplay = response.data.header
            this.footerDisplay = response.data.footer
            this.salaAdministrativaDisplay = response.data.sala
            this.$nextTick(() => {
              this.print()
            })
          })
          .catch(error => {
            this.$router.push({
              name: 'messageScreen',
              params: {
                message: `Error: ${error.error[0]}`
              }
            })
          })
      }
    },
    print: function () {
      var vm = this
      vm.ipcPrint()
      vm.ready = true
      setTimeout(function () {
        vm.$router.push({ name: 'TotemHome' })
      }, 7000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
.check-avatar {
  border: 2px solid var(--v-primary-base);
}
.check-container {
  text-align: center;
  width: 300px;
}
.checkmark {
  display: inline-block;
  margin-top: 20px;
}
.checkmark:after {
  content: "";
  display: block;
  width: 20px;
  height: 50px;
  border: solid var(--v-primary-base);
  border-width: 0 10px 10px 0;
  transform: rotate(45deg);
}

.circle-loader {
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-left-color: var(--v-primary-base);
  animation: loader-spin 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 7em;
  height: 7em;
  text-align: center;
}

.load-complete {
  -webkit-animation: none;
  animation: none;
  border-color: var(--v-primary-base);
  transition: border 500ms ease-out;
}
</style>
